import type { State } from './type';

import { IANAZone, SystemZone } from 'luxon';

export const InitialState: State = {
  timezone: IANAZone.create(new SystemZone().name),
}
